export class ImageGalleryObject {
    constructor(data) {
        this.id = data.id;
        this.title = data.title;
        this.slug = data.slug;
        this.profileImageUrl = data.profileImageUrl || data.profile_image_url_get;
    }
}